import { render, staticRenderFns } from "./Xotinqizlar.vue?vue&type=template&id=69b31dc7&"
import script from "./Xotinqizlar.vue?vue&type=script&lang=js&"
export * from "./Xotinqizlar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports